import * as React from 'react'
import { TableRow } from 'components/Table'

interface VirtualStripedTableRowProps
  extends React.HTMLAttributes<HTMLTableRowElement> {
  children?: React.ReactNode
  'data-index': number
}

/**
 * Virtual Striped Table Row
 * Uses the index as specified by the Virtuoso component to conditionally render
 * the row props.
 */
export default React.forwardRef<
  HTMLTableRowElement,
  VirtualStripedTableRowProps
>(function VirtualStripedTableRow(props, ref) {
  return <TableRow ref={ref} odd={props['data-index'] % 2 !== 0} {...props} />
})
